"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.default = react_jss_1.createUseStyles({
    colorSwatch: function (_a) {
        var theme = _a.theme, radius = _a.radius;
        return (__assign(__assign({}, theme_1.getFocusStyles(theme)), { border: 0, borderRadius: theme_1.getSizeValue({ size: radius, sizes: theme.radius }), appearance: 'none', WebkitAppearance: 'none', padding: 0 }));
    },
}, { link: true });
